import { Icon } from '@iconify/react'
import type { CampaignSaleDetailQuestionnaireAnswer } from '@/types/campaign-report'
import styles from './SaleQuestionnaireSection.module.css'

interface SaleQuestionnaireSectionProps {
  answers: CampaignSaleDetailQuestionnaireAnswer[]
}

function formatAnsweredAt(iso: string | null): string | null {
  if (!iso) return null
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return null
  const pad = (value: number) => String(value).padStart(2, '0')
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function SaleQuestionnaireSection({ answers }: SaleQuestionnaireSectionProps) {
  if (answers.length === 0) {
    return null
  }

  return (
    <section className={styles.section} aria-labelledby="sale-questionnaire-title">
      <h3 id="sale-questionnaire-title" className={styles.title}>
        <Icon icon="mdi:help-circle-outline" className={styles.titleIcon} aria-hidden />
        Questionário pós-pagamento
      </h3>
      <ul className={styles.list}>
        {answers.map((answer) => {
          const answeredAt = formatAnsweredAt(answer.answered_at)

          return (
            <li key={`${answer.question_id}-${answer.option_id}`} className={styles.item}>
              <p className={styles.question}>{answer.question_title}</p>
              <p className={styles.answer}>
                Resposta: <strong>{answer.option_label}</strong>
              </p>
              {answeredAt ? (
                <span className={styles.answeredAt}>Respondido em {answeredAt}</span>
              ) : null}
            </li>
          )
        })}
      </ul>
    </section>
  )
}
